export default __webpack_public_path__ + "static/floatingImg2-72bae986e5a607b70531ea9f3822f6a9.webp";